import React, { Component } from "react";
import {
  Container,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
} from "@material-ui/core";
import { Card } from "react-bootstrap";
import NavigateNext from "@material-ui/icons/NavigateNext";
import AlumniDescription from "./AlumniDescription";
import BreadCumb from "../Department/BreadCumb";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";
import { Menu } from "antd";

const list = [
  {
    title: "About",
    link: "/alumni/about",
  },
  {
    title: "Alumni Registration",
    link: "/alumni/registration",
  },
  {
    title: "Alumni Committee",
    link: "/alumni/committee",
  },
  {
    title: "Alumni Event",
    link: "/alumni/events",
  },
  {
    title: "Alumni Contribution",
    link: "/alumni/support",
  },
  // {
  //   title: "Prominent Alumni",
  //   link: "/alumni/prominent",
  // },
  {
    title: "Alumni Members",
    link: "/alumni/list",
  },
  {
    title: "Documents",
    link: "/alumni/documents",
  },
  
];

class AlumniComponent extends Component {
  state = {
    link: "",
  };
  componentDidMount() {
    let link = this.props.match.params.link;
    this.setState({
      link: link,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.link != this.props.match.params.link) {
      let link = this.props.match.params.link;
      this.setState({
        link: link,
      });
    }
  }

  render() {
    return (
      <div>
         <BreadCrumbOwn title="Home > Alumni" />
        <Container style={{  padding: 0 }}>
    
        <Menu theme="dark" mode="horizontal" style={{backgroundColor: "#4F58D2"}}>
            {list.map((el, index) => (
              <Menu.Item
                button
                // style={{
                //     border: "1px solid #0002",
                //     marginBottom: "2px",
                //     backgroundColor: el === this.state.com ? '#F5EB3D' : '#f9f9f9'
                // }}
                key={index}
                //onClick={() => this.setCom(el)}
                onClick={() => this.props.history.push(el.link)}
                style={{fontWeight: 700, color: "white"}}
              >
                {el.title}
              </Menu.Item>
            ))}
          </Menu>
          <Grid container spacing={2}>
            {/* <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              style={{ paddingTop: "5em" }}
            >
              <Card
                style={{
                  boxShadow: "none",
                  position: "stickey !important",
                  top: "0 !important",
                }}
              >
                <div
                  style={{
                    boxShadow: "none",
                    position: "stickey",
                    top: "0",
                  }}
                >
                  <List component="nav">
                    {list.map((el, index) => (
                      <ListItem
                        button
                        style={{
                          border: "1px solid #0002",
                          marginBottom: "2px",
                          backgroundColor: el.link === `/alumni/${this.state.link}` ? '#F5EB3D' :'#f9f9f9'
                        }}
                        key={index}
                        onClick={() => this.props.history.push(el.link)}
                      >
                        <div
                          style={{
                            fontSize: "1.2em",
                            fontWeight: "700",
                            padding: "0",
                          }}
                        >
                          {el.title}
                        </div>
                      </ListItem>
                    ))}
                  </List>
                </div>
              </Card>
            </Grid> */}

            <Grid item xs={12} sm={12} md={12} lg={12}>
              <AlumniDescription type={this.state.link} />
            </Grid>
          </Grid>
        </Container>
      </div>
    );
  }
}

export default AlumniComponent;
